import { cn } from "../lib/utils";

interface LogoIconProps {
  className?: string;
  /** Variante blanche pour fond foncé. */
  light?: boolean;
}

/**
 * Icône Ommistack : un cercle qui contient 3 hexagones empilés.
 * Utilise le PNG officiel servi depuis /public.
 */
export function LogoIcon({ className, light = false }: LogoIconProps) {
  return (
    <img
      src={light ? "/logo-icon-white.png" : "/logo-icon.png"}
      alt="Ommistack"
      className={cn("shrink-0 select-none", className)}
      draggable={false}
    />
  );
}

interface LogoFullProps {
  className?: string;
  /** Hauteur Tailwind du logo (défaut : `h-9`). */
  size?: string;
}

/**
 * Logo complet « ommistack » officiel (icône + wordmark).
 * Source : /public/logo-full.png.
 */
export function LogoFull({ className, size = "h-9" }: LogoFullProps) {
  return (
    <img
      src="/logo-full.png"
      alt="Ommistack"
      className={cn("w-auto select-none", size, className)}
      draggable={false}
    />
  );
}
